export default __webpack_public_path__ + "static/media/spiritualfeedback.55bc2e30.png";